import { useEffect, useRef } from 'react';
import { fetchHeaderFooter } from '../api/headerFooterApi';

const ScriptInjector = ({ enabled = false }) => {
  const hasInjected = useRef(false);

  useEffect(() => {
    // Meta tags ready nahi hain ya scripts already inject ho chuke hain
    if (!enabled || hasInjected.current) {
      return;
    }

    // Immediately mark as injected to prevent duplicate API calls
    // during re-renders or route changes.
    hasInjected.current = true;

    const injectScripts = async () => {
      try {
        const response = await fetchHeaderFooter();

        if (response.success && response.data) {
          const headerScripts = response.data.filter(
              item =>
                  item.position === 'header' &&
                  item.is_active
          );

          const footerScripts = response.data.filter(
              item =>
                  item.position === 'footer' &&
                  item.is_active
          );

          const parseAndInject = (
              scriptItem,
              parentElement
          ) => {
            if (!scriptItem.code) {
              console.warn(
                  `ScriptInjector: Script item "${scriptItem.name}" has no code content.`
              );
              return;
            }

            // Create a temporary div to parse
            // the HTML string.
            const tempDiv =
                document.createElement('div');

            tempDiv.innerHTML =
                scriptItem.code;

            // Find all script tags.
            Array.from(
                tempDiv.querySelectorAll('script')
            ).forEach(foundScript => {
              const newScript =
                  document.createElement('script');

              // Copy all attributes
              // such as async, defer, type, src etc.
              Array.from(
                  foundScript.attributes
              ).forEach(attr => {
                newScript.setAttribute(
                    attr.name,
                    attr.value
                );
              });

              // External script
              if (foundScript.src) {
                newScript.src =
                    foundScript.src;
              } else {
                // Inline script
                newScript.innerHTML =
                    foundScript.innerHTML;
              }

              parentElement.appendChild(
                  newScript
              );
            });
          };

          // Inject Header Scripts
          headerScripts.forEach(
              scriptItem => {
                parseAndInject(
                    scriptItem,
                    document.head
                );
              }
          );

          // Inject Footer Scripts
          footerScripts.forEach(
              scriptItem => {
                parseAndInject(
                    scriptItem,
                    document.body
                );
              }
          );
        }
      } catch (error) {
        console.error(
            'ScriptInjector error:',
            error
        );

        // Allow retry if API request fails.
        hasInjected.current = false;
      }
    };

    injectScripts();
  }, [enabled]);

  return null;
};

export default ScriptInjector;